import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import NewRunSiteDataSyncTable from "./RunSiteDataSyncTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const RunSiteDataSync = (props) => {
  const classes = useStyles();

  const [dataObj, setDataObj] = useState({
    tableData: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/LocationService/GetLocationsAuditTable")
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          tableData: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <NewRunSiteDataSyncTable data={dataObj.tableData} />
        </div>
      )}
    </>
  );
};

export default RunSiteDataSync;
